<template>
  <div class="wlx-apply-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">培训报名表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content">
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="u-label-title">姓名</td>
          <td colspan="2">
            <el-input v-model="form.name" disabled></el-input>
          </td>
          <td class="u-label-title">性别</td>
          <td colspan="2">
            <el-select v-model="form.sex" placeholder="请选择" class="train-select-con" disabled>
              <el-option label="男" :value="0"></el-option>
              <el-option label="女" :value="1"></el-option>
            </el-select>
          </td>
          <td colspan="2" class="u-label-title">手机</td>
          <td colspan="2">
            <el-input v-model="form.phoneNum" disabled></el-input>
          </td>
          <td colspan="3" rowspan="4" width="160px">
            <div class="user-avatar-con">
              <img :src="form.avatar" alt class="user-avatar-img" />
            </div>
          </td>
        </tr>
        <tr>
          <td class="u-label-title">邮箱</td>
          <td colspan="2">
            <el-input v-model="form.email" disabled></el-input>
          </td>
          <td class="u-label-title">发票抬头</td>
          <td colspan="2">
            <el-input v-model="form.invoice" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">纳税人识别号</td>
          <td colspan="2">
            <el-input v-model="form.payTaxes" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title">职务</td>
          <td colspan="2">
            <el-input v-model="form.post" disabled></el-input>
          </td>
          <td class="u-label-title">单/合住</td>
          <td colspan="2">
            <el-select v-model="form.liveWay" placeholder="请选择" class="train-select-con" disabled>
              <el-option label="单住" :value="1"></el-option>
              <el-option label="合住" :value="2"></el-option>
            </el-select>
          </td>
          <td colspan="2" class="u-label-title">付款方式</td>
          <td colspan="2">
            <el-select v-model="form.payWay" placeholder="请选择" class="train-select-con" disabled>
              <el-option label="公对公汇款" :value="1"></el-option>
              <el-option label="现场刷卡" :value="2"></el-option>
              <el-option label="微信支付（线上培训）" :value="3"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="u-label-title">身份证号</td>
          <td colspan="4">
            <el-input v-model="form.IDNum" disabled></el-input>
          </td>
          <td class="u-label-title">学校</td>
          <td colspan="4">
            <el-input v-model="form.school" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">地址</td>
          <td colspan="11">
            <el-input v-model="form.address" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">备注</td>
          <td colspan="11">
            <el-input type="textarea" v-model="form.notes" disabled></el-input>
          </td>
        </tr>
      </table>
      <div class="back-to-manager">
        <el-button type="primary" @click="fanhui">返回</el-button>
        <el-button type="danger" @click="deleteEnroll">删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import Bus from "components/bus.js";
export default {
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      form: {
        avatar: "",
        name: "",
        school: "",
        sex: "",
        post: "",
        phoneNum: "",
        email: "",
        address: "",
        invoice: "",
        payTaxes: "",
        liveWay: "",
        payWay: ""
      },
      timer: "",
      IsTipsDialog: true,
      showObject: {
        isShow: false
      }
    };
  },
  props: {
    signUpId: {
      type: String,
      default: ""
    },
    activityId: {
      type: String,
      default: ""
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function() {
      return this.$store.state.association;
    }
  },
  components: {
    avatarUpload
  },
  created() {
    this.getSignUpDetail();
  },
  methods: {
    getSignUpDetail() {
      this.$http
        .post("/api/XOrg/SpecialActivity/getPeiXunEnrollInfo", {
          id: this.signUpId
        })
        .then(res => {
          if (res.code > 0) {
            this.form.name = res.info.Name;
            this.form.avatar = res.info.Photo;
            this.form.school = res.info.SchoolTitle;
            this.form.IDNum = res.info.IDNum;
            this.form.sex = res.info.Sex;
            this.form.post = res.info.Post;
            this.form.phoneNum = res.info.Phone;
            this.form.email = res.info.Email;
            this.form.address = res.info.Address;
            this.form.invoice = res.info.Invoice;
            this.form.payTaxes = res.info.TaxNumber;
            this.form.liveWay = res.info.StayType;
            this.form.payWay = res.info.PaymentType;
            this.form.notes = res.info.Note;
          } else {
            return false;
          }
        });
    },
    backToHome() {
      this.$router.push({
        name: "TeaPeiXunEnrollManager"
      });
    },
    fanhui() {
      this.$router.go(-1);
    },
    deleteEnroll(){
      var that = this;
      this.$confirm('此操作将删除该报名记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$http
            .post("/api/XOrg/SpecialActivity/deletePeiXunEnroll", {
              id: this.signUpId
            })
            .then(res => {
              if (res.code > 0) {
                that.$message.success(res.msg);
                that.fanhui();
              }else{
                that.$message.warning(res.msg);
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
 
};
</script>

<style lang="scss">
.wlx-apply-table-wrapper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .apply-table-content {
    margin: -325px auto 0;
    padding: 20px 0;
    padding-top: 50px;
    width: 1000px;
    background: #fff;
  }
  .p-down-applyTable-btn {
    text-align: right;
    color: #0365f5;
    padding: 0 22px 20px 0;
    cursor: pointer;
    font-size: 17px;
  }
  .apply-table-title {
    padding: 20px 0;
    text-align: center;
  }
  .submit-apply-btn {
    padding: 20px 0;
    text-align: center;
  }
  .label-job-con {
    padding: 0 20px;
  }
  table {
    margin: 0 auto;
    width: 960px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
  }
  .u-label-title {
    font-weight: bold;
  }
  .demo-table {
    margin-top: 100px;
  }
  .expert-certify-ul {
    height: 100%;
  }
  .expert-certify-li {
    width: 25%;
  }
  .certify-li-cell {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
  }
  .certify-li-cell-num {
    border-top: none;
  }
  .fistCertify {
    .certify-li-cell {
      border-left: none;
    }
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .input-edu .el-input__inner {
    height: 82px;
    line-height: 82px;
  }
  .el-textarea__inner:focus {
    border: none;
  }
  .el-input__inner:focus {
    border: none;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input.is-disabled .el-input__inner {
    border-radius: 0;
    color: #000;
  }
  table td {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
    text-align: center;
  }
  .label-opinion-title {
    padding: 10px;
    text-align: left;
  }
  .sp-mark-label {
    color: red;
  }
  .h4-major-title {
    padding: 10px 0;
  }
  td {
    height: 40px;
    // width: 76.9px;
    font-size: 16px;
  }
  .train-select-con {
    width: 100%;
  }
  .p-sign-up-tip {
    padding: 10px 0 0 20px;
  }
  .p-sign-up-tip-1 {
    margin-top: 40px;
  }
  .submit-btn {
    padding: 20px 0;
    text-align: center;
  }
  .wlx-is-fill-signUp-con {
    font-size: 16px;
    .p-name-pass-tip-con {
      margin-top: 10px;
      color: red;
    }
  }
  .user-avatar-con {
    height: 100%;
    overflow: hidden;
    line-height: 160px;
    text-align: center;
    .user-avatar-img {
      max-width: 148px;
      vertical-align: middle;
    }
  }
  .back-to-manager {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
